import useQueryParams from "modules/queryParams/hooks/useQueryParams";

const useAuthNavigation = (pageUrl: string) => {
  const { redirectTo } = useQueryParams();

  // Encode params, so they wont be lost during redirects
  return redirectTo
    ? `/${pageUrl}?redirectTo=${encodeURIComponent(redirectTo.toString())}`
    : `/${pageUrl}`;
};

export default useAuthNavigation;
